import { polygonContainsPoint, type PolygonPoint } from "../lib/C1_polygonPlacement";
import { clampToRoomPolygon, projectPointToWall, type RoomPlacementGeometry } from "../furniture/C1_roomPlacementGeometry";

/** Keeps automatic room equipment and add proposals inside usable space, with separated anchors. */
export function roomEquipmentPositions(
  proposed: readonly PolygonPoint[], geometry: RoomPlacementGeometry, anchor: PolygonPoint,
): PolygonPoint[] {
  if (geometry.polygon.length < 3) return proposed.map(point => ({...point}));
  const occupied: PolygonPoint[] = [];
  for (const position of proposed) {
    const usable = (point: PolygonPoint) => polygonContainsPoint(geometry.polygon, point) &&
      geometry.walls.every(wall => projectPointToWall(point, wall).distance >= 0.1) &&
      occupied.every(other => Math.hypot(other.x - point.x, other.y - point.y) >= 0.25);
    if (usable(position)) {
      occupied.push({...position});
      continue;
    }
    const clamped = clampToRoomPolygon(position, geometry);
    const candidates = [position, clamped, anchor];
    // A bounded local search avoids overlapping suggestions on a concave boundary.
    for (let x = -8; x <= 8; x++) for (let y = -8; y <= 8; y++) {
      candidates.push({x: anchor.x + x * 0.35, y: anchor.y + y * 0.35});
    }
    const point = candidates.filter(usable).sort((a, b) =>
      Math.hypot(a.x - position.x, a.y - position.y) - Math.hypot(b.x - position.x, b.y - position.y))[0] ?? clamped;
    occupied.push({...point});
  }
  return occupied;
}